const huayType = {
    "3ตัวบน": "bon_3",
    "3ตัวโต้ด": "tode_3",
    "3ตัวหน้า": "na_3",
    "3ตัวล่าง": "lang_3",
    "2ตัวบน": "bon_2",
    "2ตัวล่าง": "lang_2",
    "1ตัวบน": "bon_1",
    "1ตัวล่าง": "lang_1"
};
const lotteryProcessor = (sheetData) => {
    try {
        if (!sheetData || !Array.isArray(sheetData)) {
            throw new Error('Invalid data provided.');
        }

        const result = [];
        for (const element of sheetData) {
            const userName = element["ชื่อโพย"];
            const betType = huayType[element["ประเภทแทง"]];

            if (!betType) {
                throw new Error(`Unknown bet type: ${element["ประเภทแทง"]}`);
            }

            let user = result.find(item => item.name === userName);

            if (!user) {
                user = { name: userName, ticketList: [] };
                result.push(user);
            }

            user.ticketList.push({
                betType: betType,
                betNumber: element["เลขแทง"],
                betAmount: element["ยอดแทง"]
            });
        }

        return result;
    } catch (error) {
        console.error(error);
        return error.message;
    }
};

export default lotteryProcessor;